module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAd0lEQVQ4EaXBMRIDQRACseb/j8aQEUxwW5bEn8SfxMHBUBAOhoqDg6EgHAwVBwdDQTgYKg4OhoJwMFQcHAwF4WCoODgYCsLBUHFw8IGKg4MPVBwcfKDi4OADFQ8cDBUPHAwVDxwMFQ8cDBUPHAwVDxwMFX8Sf/oBGjlYFaVAsmwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_04.png
// module id = 237
// module chunks = 0